import styled from '@emotion/styled';
import { spacing, breakpoints } from '@naf/theme';
import { themeLight } from '@lib/nafTheme';

export const CardBackground = styled.div<{ $backgroundSrc: string }>`
  background-image: url('${({ $backgroundSrc }) => $backgroundSrc}');
  background-position: center;
  background-size: cover;
  color: ${themeLight.background.default};
`;

export const TextContainer = styled.div`
  max-width: ${breakpoints.s};
  padding: ${spacing.space40} ${spacing.space24};
  margin: 0 auto;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  & h2 {
    text-align: center;
    margin-top: 0;
    margin-bottom: ${spacing.space16};
  }

  & > a,
  .CtaButton {
    margin-top: ${spacing.space24};
    box-shadow: 0 2px ${spacing.space12} rgba(0, 0, 0, 0.24);
    // For shadow to match corners of the button inside
    border-radius: 2px;
  }

  h2,
  h3,
  h6 {
    text-shadow: 0 2px ${spacing.space12} rgba(0, 0, 0, 0.24);
  }
`;

export const LogoImage = styled.img`
  max-height: ${spacing.space32};
  margin-bottom: ${spacing.space24};
`;
